import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Error } from '../business/error';

export enum ErrorType {
    CUSTOM = 'custom',
    NOT_FOUND = 'not-found',
    DEFAULT = 'default',
}

@Injectable({
    providedIn: 'root',
})
export class ErrorPageService {
    /**
     * Error object to be interpolated in Error page
     * @type {Error}
     */
    private _error: Error;

    public constructor(private router: Router) {
        this._error = new Error();
    }

    /**
     * Getter on Error object
     * @returns {Error}
     */
    public getError(): Error {
        return this._error;
    }

    /**
     * Route to Error page with custom title and description
     */
    public showCustomErrorPage(error: Error, skipLocationChange = true): void {
        this._error.title = error.title;
        this._error.description = error.description;
        this.router.navigate(['service-indisponible'], {
            skipLocationChange,
            queryParams: { canRetry: skipLocationChange },
        });
    }

    /**
     * Route to Error page with default title and description
     */
    public showDefaultErrorPage(skipLocationChange = true): void {
        this.router.navigate(['indisponible'], {
            skipLocationChange,
            queryParams: { canRetry: skipLocationChange },
        });
    }

    /**
     * Route to Unauthorized page
     * @param {string} returnUrl Return URL after authentication
     */
    public showUnauthorizedPage(returnUrl?: string): void {
        this.router.navigate(['identification', { returnUrl }]);
    }
}
